import {Component, HostListener, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from "@irb/app.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IrbEditorPortfolioResultService} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service";
import {ModelUsedInRebalanceDialogGridLayoutService} from "@irb/irb-editors/editor-portfolio-result/model-used-in-rebalance-dialog/model-used-in-rebalance-dialog.grid-layout.service";

@Component({ standalone: false,
    selector: 'irb-model-used-in-rebalance-dialog',
    templateUrl: './model-used-in-rebalance-dialog.component.html',
    styleUrls: ['./model-used-in-rebalance-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ModelUsedInRebalanceDialogComponent implements OnInit {
    portfolioResultData: any;
    portfolioSummaryData: any;
    grid: any;
    gridOptions: any;
    frameworkComponents: any;
    totalPercent: number;
    defaultGridHeights: {
        height: string,
        minHeight:string,
        maxHeight: string,
        domLayout:string
    };
    isUiTest = false;
    constructor(private as: AppService,
                public dialogRef: MatDialogRef<ModelUsedInRebalanceDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private gls: ModelUsedInRebalanceDialogGridLayoutService,
                private prs: IrbEditorPortfolioResultService) {
    }

    ngOnInit(): void {
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities.</span>",
            context: {componentParent: this},
            suppressHorizontalScroll: true
        };
        this.frameworkComponents = this.gls.getFrameworkComponents();
        this.portfolioResultData = this.mdd.portfolioResultData;
        this.computeGridHeights(0);
    }

    close() {
        this.dialogRef.close();
    }

    onGridReady(params: any) {
        this.grid = params;
        this.getPortfolioSummary();
    }

    getPortfolioSummary() {
        let request: any = {
            method: "getModelHistory",
            modelName: this.portfolioResultData.historyModelName,
            portfolioId: this.portfolioResultData.portfolioId,
            portfolioName: this.portfolioResultData.portfolioName,
            rebalId: this.portfolioResultData.rebalId
        };
        this.prs.getPortfolioResult(request).subscribe((data: any) => {
            this.portfolioSummaryData = data;
            this.totalPercent = 0;
            if (this.portfolioSummaryData && this.portfolioSummaryData.modelHistoryList && this.portfolioSummaryData.modelHistoryList.length > 0) {
                this.portfolioSummaryData.modelHistoryList.forEach((modelHistoryData: any) => {
                    this.totalPercent += modelHistoryData.targetPercentage;
                });
                this.computeGridHeights(this.portfolioSummaryData.modelHistoryList.length);
            } else {
                this.computeGridHeights(0);
            }
            setTimeout(() => {
                this.setTotalPercent(this.totalPercent);
            });

        }, () => {
        }, () => {
        });
    }

    setTotalPercentFinal(headerTarget: any, portSummaryModelHistorySymbolEl: any, portSummaryModelSymbolDescriptionEl: any, totalValue: any) {
        const pos = headerTarget.getBoundingClientRect();
        const symbolElPos = portSummaryModelHistorySymbolEl.getBoundingClientRect();
        const symbolDescElPos = portSummaryModelSymbolDescriptionEl.getBoundingClientRect();
        let leftPos = symbolElPos.width + symbolDescElPos.width + pos.width - 58;
        leftPos = leftPos > 350 ? 350 : leftPos;
        if (Number(totalValue) < 100) {
            leftPos += 5;
        }

        const totalValEl: any = document.querySelector('#model-allocation-total-percent-value');
        if (totalValEl) {
            totalValEl.style.left = leftPos + 'px';
            totalValEl.innerHTML = totalValue.toFixed(1) + '%';
        }
    }

    private setTotalPercent(totalValue: any) {
        totalValue = totalValue ? totalValue : 0;

        const headerTarget = document.querySelector('.editHeaderModelPercent');
        const portSummaryModelHistorySymbolEl= document.querySelector('.portSummaryModelHistorySymbol');
        const portSummaryModelSymbolDescriptionEl= document.querySelector('.portSummaryModelSymbolDescription');
        if (headerTarget) {
            this.setTotalPercentFinal(headerTarget, portSummaryModelHistorySymbolEl, portSummaryModelSymbolDescriptionEl, totalValue);
        }
    }

    @HostListener("window:resize")
    onResize() {

        setTimeout(() => {
            this.setTotalPercent(this.totalPercent);
        });
    }

    computeGridHeights(totalRecords: number) {
        let defaultHeights: any;
        if(totalRecords <= 9 ) {
            defaultHeights ={
                height: null,
                minHeight:null,
                maxHeight: null,
                domLayout:'autoHeight'
            };
        } else {
            defaultHeights ={
                height: '330px',
                minHeight:'210px',
                maxHeight: '330px',
                domLayout:'normal'
            };
        }
        this.defaultGridHeights = defaultHeights;
        if(this.grid && this.grid.api ) {
            this.grid.api.setGridOption('domLayout', this.defaultGridHeights.domLayout);
        }

    }


}
